import React, { useState } from 'react';
import { Link } from 'react-router-dom';
export function MobileNav() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      {/* Desktop Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#2B2B2B]" data-id="element-136">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between" data-id="element-137">
          <Link to="/" className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition-opacity flex-shrink-0" onClick={() => setIsOpen(false)} data-id="element-138">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jXd6KyuddrgAfqwwkkpUrR/Lazy_Monk_Labs_Logo.png" alt="Lazy Monk Labs Logo" className="h-6 sm:h-7 md:h-8 w-auto" width="32" height="32" data-id="element-139" />
            <span className="hidden sm:inline text-sm md:text-base font-mono tracking-tight text-gray-400" data-id="element-140">
              Lazy Monk Labs
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8" data-id="element-141">
            <a href="https://decoder-website.vercel.app/reports" target="_blank" rel="noopener noreferrer" className="text-sm text-[#F5F5F5] hover:text-gray-400 transition-colors font-medium whitespace-nowrap" data-id="element-142">
              Decodes
            </a>
            <Link to="/mirrors/work" className="text-sm text-[#F5F5F5] hover:text-gray-400 transition-colors font-medium whitespace-nowrap" data-id="element-143">
              Work Mirror
            </Link>
            <Link to="/decoder" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono whitespace-nowrap" data-id="element-144">
              Decoder
            </Link>
            <Link to="/careers" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono whitespace-nowrap" data-id="element-145">
              Careers
            </Link>
            <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono whitespace-nowrap" data-id="element-146">
              Contact
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-[#F5F5F5] hover:text-gray-400 transition-colors flex-shrink-0" aria-label="Toggle menu" aria-expanded={isOpen} data-id="element-147">
            {isOpen ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-148">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-149" />
              </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-150">
                <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-151" />
              </svg>}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && <div className="md:hidden border-t border-[#2B2B2B] bg-[#0A0A0A]" data-id="element-152">
            <div className="px-4 py-6 space-y-4" data-id="element-153">
              <a href="https://decoder-website.vercel.app/reports" target="_blank" rel="noopener noreferrer" className="block py-3 text-base text-[#F5F5F5] hover:text-gray-400 transition-colors font-medium" onClick={() => setIsOpen(false)} data-id="element-154">
                Decodes
              </a>
              <Link to="/mirrors/work" className="block py-3 text-base text-[#F5F5F5] hover:text-gray-400 transition-colors font-medium" onClick={() => setIsOpen(false)} data-id="element-155">
                Work Mirror
              </Link>
              <Link to="/decoder" className="block py-3 text-base text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" onClick={() => setIsOpen(false)} data-id="element-156">
                Decoder
              </Link>
              <Link to="/careers" className="block py-3 text-base text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" onClick={() => setIsOpen(false)} data-id="element-157">
                Careers
              </Link>
              <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="block py-3 text-base text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" onClick={() => setIsOpen(false)} data-id="element-158">
                Contact
              </a>
            </div>
          </div>}
      </nav>
    </>;
}